<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="savedMonies"
      :items-per-page="500"
      class="elevation-1 mb-3"
    >
      <template v-slot:item="row">
        <tr>
          <td>{{ row.item.memberPersonalCode }}</td>
          <td>{{ row.item.memberFullName }}</td>
          <td>
            {{
              `${row.item.targetMonth_Persian.year}/${row.item.targetMonth_Persian.month}`
            }}
          </td>
          <td class="text-center">
            {{ row.item.amount.toString().toPriceFormat() }} ریال
          </td>
        </tr>
      </template>
    </v-data-table>

    <div
      v-if="loading"
      class="loading flex-start"
    >
      <v-progress-circular
        :size="50"
        color="white"
        indeterminate
      />
      <div class="white--text mt-2">
        در حال بارگذاری...
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/util/app-api'
  import toast from '@/util/toast'

  export default {
    name: 'SavedMoniesByMonthView',
    components: {},
    props: {
      date: { type: String },
    },
    data () {
      return {
        errorMessages: '',
        savedMonies: [],
        headers: [
          {
            text: 'کد پرسنلی',
            align: 'center',
            sortable: true,
            value: 'memberPersonalCode',
          },
          {
            text: 'نام عضو',
            align: 'center',
            sortable: true,
            value: 'memberFullName',
          },
          {
            text: 'ماه',
            align: 'center',
            sortable: true,
            value: 'targetMonth_Persian',
          },
          {
            text: 'مبلغ',
            align: 'right',
            sortable: true,
            value: 'amount',
          },
        ],
        loading: false,
      }
    },
    mounted () {},
    methods: {
      loadData () {
        if (!this.date || this.date === '') {
          return
        }
        this.loading = true
        api
          .get(
            'admin/UserSavedMoney/getListByTargetMonth/' +
              this.date.replaceAll('/', '-'),
            null,
          )
          .then((response) => {
            this.savedMonies = response
          })
          .catch((err) => {
            toast.error(err.message)
          })
          .finally((x) => {
            this.loading = false
          })
      },
    },
  }
</script>
<style>
</style>
